import { AttachMoney as AttachMoneyIcon } from '@mui/icons-material';
import { Box, Chip, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

export interface AmountSummaryHeaderProps {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string | React.ReactNode;
  totalAmount?: number;
  totalAmountLabel?: string;
  actionButton?: React.ReactNode;
  iconColor?: string;
  formatMoney?: (value: number) => string;
  sx?: SxProps<Theme>;
}

const AmountSummaryHeader: React.FC<AmountSummaryHeaderProps> = ({
  icon,
  title,
  subtitle,
  totalAmount,
  totalAmountLabel = 'CLP',
  actionButton,
  iconColor = 'primary.main',
  formatMoney,
  sx,
}) => {
  const defaultIcon = icon || <AttachMoneyIcon sx={{ fontSize: '1rem' }} />;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: '100%', mb: 2, ...sx }}
    >
      <Box
        sx={{
          backgroundColor: iconColor,
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
      >
        {defaultIcon}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Box sx={{ mt: 0.5 }}>
            {typeof subtitle === 'string' ? (
              <Chip
                label={subtitle}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ height: '18px', fontSize: '0.65rem' }}
              />
            ) : (
              subtitle
            )}
          </Box>
        )}
      </Box>
      {totalAmount !== undefined && totalAmount > 0 && (
        <Box sx={{ textAlign: 'right' }}>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="flex-end"
            spacing={0.75}
          >
            <Typography variant="h4" color="primary">
              {formatMoney ? formatMoney(totalAmount) : totalAmount}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {totalAmountLabel}
            </Typography>
          </Stack>
        </Box>
      )}
      {actionButton && <Box>{actionButton}</Box>}
    </Stack>
  );
};

export default AmountSummaryHeader;
